var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0519 5.05375H10.7369C10.0388 5.05375 9.47313 4.48806 9.47313 3.79C9.47313 3.09319 10.0388 2.5275 10.7369 2.5275H17.0519C17.7499 2.5275 18.3156 3.09319 18.3156 3.79C18.3156 4.48806 17.7499 5.05375 17.0519 5.05375ZM0 0V22.1056C0 23.1471 0.852906 24 1.89438 24H25.8944C26.9358 24 27.7888 23.1471 27.7888 22.1056V0H0Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8956 10.105C9.65983 10.105 5.93727 12.2991 3.80188 15.6133L4.5 17L6.5 20.5L7.5 22.5L8 23.5L8.5 24L9.65234 23.9987L9 22L9.5 20L11.5 18L13.8956 16.6485H24.5863C22.5995 12.7648 18.5573 10.105 13.8956 10.105Z",
    fill: "#DB4437",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8949 22.1056C25.8949 20.1413 25.4229 18.2869 24.5862 16.6498H13.8955L18 19.5L18.5 21.5L18.1388 24H25.745C25.8437 23.3831 25.8949 22.75 25.8949 22.1056Z",
    fill: "#FFCD40",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8955 16.6498C10.8823 16.6498 8.44092 19.0924 8.44092 22.1056C8.44092 22.7725 8.5608 23.4106 8.77933 24H9.96316C9.68594 23.4268 9.53109 22.7837 9.53109 22.1056C9.53109 19.6943 11.4854 17.7412 13.8955 17.7412C16.3056 17.7412 18.26 19.6943 18.26 22.1056C18.26 22.785 18.1051 23.4268 17.8279 24H19.0117C19.2302 23.4093 19.3501 22.7712 19.3501 22.1056C19.3501 19.0924 16.9075 16.6498 13.8955 16.6498Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8947 17.7412C11.4846 17.7412 9.53027 19.6943 9.53027 22.1056C9.53027 22.785 9.68512 23.4268 9.96235 24H17.8271C18.1043 23.4268 18.2591 22.7837 18.2591 22.1056C18.2579 19.6943 16.3048 17.7412 13.8947 17.7412Z",
    fill: "#4285F4",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M0 0V12.0006H27.7888V0H0ZM17.0519 5.05375H10.7369C10.0388 5.05375 9.47313 4.48806 9.47313 3.79C9.47313 3.09319 10.0388 2.5275 10.7369 2.5275H17.0531C17.7512 2.5275 18.3169 3.09319 18.3169 3.79C18.3156 4.48806 17.7499 5.05375 17.0519 5.05375Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M27.7888 11.842H0V12.0006H27.7888V11.842Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M27.7888 12.0006H0V12.1592H27.7888V12.0006Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M0 0V0.158593H27.7888V0H0ZM17.0519 5.05375H10.7369C10.0663 5.05375 9.51808 4.52927 9.47812 3.86992C9.47437 3.89614 9.47313 3.92237 9.47313 3.94859C9.47313 4.64665 10.0388 5.21109 10.7369 5.21109H17.0519C17.7499 5.21109 18.3156 4.64665 18.3156 3.94859C18.3156 3.92237 18.3144 3.89614 18.3106 3.86992C18.2707 4.52802 17.7237 5.05375 17.0519 5.05375Z",
    fill: "#212121"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.8944 23.8414H1.89438C0.852906 23.8414 0 22.9898 0 21.947V22.1056C0 23.1471 0.852906 24 1.89438 24H25.8944C26.9358 24 27.7888 23.1471 27.7888 22.1056V21.947C27.7888 22.9898 26.9358 23.8414 25.8944 23.8414ZM10.7369 2.52627H17.0519C17.7225 2.52627 18.2707 3.05075 18.3106 3.7101C18.3119 3.68387 18.3156 3.65765 18.3156 3.63142C18.3156 2.93337 17.7499 2.36768 17.0519 2.36768H10.7369C10.0388 2.36768 9.47313 2.93337 9.47313 3.63142C9.47313 3.65765 9.47437 3.68387 9.47812 3.7101C9.51808 3.05075 10.065 2.52627 10.7369 2.52627Z",
    fill: "#231F20"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79862 15.6183C2.59482 17.4889 1.89551 19.7155 1.89551 22.1056C1.89551 22.75 1.94671 23.3831 2.04536 24H8.68629L3.79862 15.6183Z",
    fill: "#0F9D58",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.7682a6652cd669edef01681e8b3dfa3b.svg";
export { ForwardRef as ReactComponent };